import * as types from '../mutation-types'
import axios from 'axios'
import { buildFilterTabData, flatten } from '~/helpers/data-structure'
import contactsService from '../services/contacts'
import usersService from '../services/users'

// state
export const state = {
  companies: { data: [], current_page: 1, total: 0, total_pages: 0, per_page: 50 },
  company: null,
  filterTabs: [],
  responseMessage: '',
  reps: [],
  countries: []
}

// getters
export const getters = {
  companies: state => state.companies,
  company: state => state.company,
  getSelectedChildrenFilterTabItems: state => {
    return state.filterTabs
      ? flatten(state.filterTabs)
        .filter(item => !!item.checked)
      : []
  },
  responseMessage: state => state.responseMessage,
    reps: state => state.reps,
    countries: state => state.countries,
}

// mutation
export const mutations = {
  [types.FETCH_ADMIN_CONTACTS_SUCCESS] (state, { companies }) {
    state.companies = companies
  },
  [types.FETCH_ADMIN_CONTACT_BY_ID] (state, payload) {
    state.company = payload
  },
  'UPDATE_COMPANY_RELATION' (state, payload) {
    state.company = payload.data
    state.responseMessage = payload.message
    // if(payload.address_relation) {
    //   state.company.addresses = state.company.addresses.map(address => {
    //     if(address.address_id == payload.address_id) {
    //       return {...address, ...payload};
    //     }
    //     return address;
    //   })
    //   console.log(state.company.addresses);
    // }
  },
  [types.UPDATE_COMPANY_INFO] (state, payload) {
    state.company.company_info = {
      ...state.company.company_info,
      ...payload
    }
  },
  'UPDATE_COMPANY_BUYER' (state, payload) {
    state.company.buyers = state.company.buyers.map(buyer => {
      if (buyer.buyer_id === payload.buyer_id) {
        return { ...buyer, ...payload }
      }
      return buyer
    })
  },
  'ADD_COMPANY_BUYER' (state, payload) {
    state.company.buyers.push(payload)
  },
  [types.FETCH_FILTER_TAB_CONTACTS_SUCCESS] (state, { filterTabs }) {
    state.filterTabs = buildFilterTabData(filterTabs)
  },
  [types.SET_CONTACTS_FILTER_TAB] (state, { filterTabs }) {
    state.filterTabs = filterTabs
  },
  [types.SET_RESPONSE_MSG] (state, { message }) {
    state.responseMessage = message
  },
    'LOAD_REP_LIST' (state, { reps }) {
        state.reps = reps
    },
    'LOAD_COUNTRIES' (state, { countries }) {
        state.countries = countries
    },
}

// actions
export const actions = {
  async fetchAdminContacts ({ commit }, payload) {
    const params = {}
    if (payload) {
      if (payload.city) params.city = payload.city
      if (payload.state) params.state = payload.state
      if (payload.company) params.company = payload.company
      if (payload.page) params.page = payload.page ?? 1
      if (typeof payload.search === 'string' && payload.search.trim()) {
        params.search = payload.search.trim()
      }
      if (payload.sort_by && payload.sort_order) {
        params.sort_by = payload.sort_by
        params.sort_order = payload.sort_order
      }
    }

    const { data: { data } } = await contactsService.fetchAdminContacts(params)

    commit(types.FETCH_ADMIN_CONTACTS_SUCCESS, {
      companies: data
    })
  },
  async fetchAdminContactById ({ commit }, id) {
    if (!id) {
      console.log('Trying to fetch company data for null id')
    }
    const { data: { data } } = await axios.get(`/api/company/company-info/${id}`)

    commit(types.FETCH_ADMIN_CONTACT_BY_ID, data)
  },
  async updateCompanyInfo ({ commit }, { companyId, payload }) {
    await axios.patch(`/api/company/${companyId}/update`, payload)

    commit('UPDATE_COMPANY_INFO', payload)
  },
  async updateCompanyRelation ({ commit, dispatch }, { companyId, payload }) {
    const { data: { data, message } } = await contactsService.updateCompanyRelation(companyId, payload)

    commit('UPDATE_COMPANY_RELATION', {data, message})
    await dispatch('auth/fetchUser', null, { root: true })
  },
  async updateCompanyBuyer ({ commit, dispatch }, { buyerId, payload }) {
    const { data: { data } } = await axios.patch(`/api/buyer/${buyerId}/update`, payload)

    commit('UPDATE_COMPANY_BUYER', data)
    await dispatch('auth/fetchUser', null, { root: true })
  },
  async fetchFilterTabsData ({ commit }) {
    const { data } = await contactsService.fetchFiltersTabData()

    commit(types.FETCH_FILTER_TAB_CONTACTS_SUCCESS, {
      filterTabs: data
    })
  },
  async addAddress ({ dispatch, commit }, payload) {
    try {
      const response = await contactsService.addAddress(payload)
      const { data } = response
      const responseMessage = data.message
      commit('SET_RESPONSE_MSG', { message: responseMessage });
      await dispatch('fetchAdminContactById', payload.company_id)
      await dispatch('auth/fetchUser', null, { root: true })

    } catch (error) {
      console.log('Error: ', error)
      throw error
    }
  },
  async updateAddress ({ dispatch, commit }, {id, payload}) {
    try {
      const response = await contactsService.updateAddress(id, payload);
      const { data } = response
      const responseMessage = data.message
      commit('SET_RESPONSE_MSG', { message: responseMessage });
      await dispatch('fetchAdminContactById', payload.company_id)
      await dispatch('auth/fetchUser', null, { root: true })
    } catch (error) {
      console.log('Error: ', error)
      throw error
    }
  },
  async deleteAddress({ commit, dispatch }, { id, data = null }) {
    try {
      const response = await contactsService.deleteAddress(id, data);
      const { message } = response.data;

      await dispatch('auth/fetchUser', null, { root: true });
      return message;
    } catch (error) {
      console.error('Failed to delete address');
    }
  },
  setContactsFilterTab({ commit }, payload) {
    commit(types.SET_CONTACTS_FILTER_TAB, payload)
  },
    async fetchCountries ({ commit, state }) {
        if (state.countries.length > 0) return
        try {
            const response = await contactsService.fetchCountries()
            commit('LOAD_COUNTRIES', { countries: response.data.data })
        } catch (error) {
            console.error("Error fetching countries:", error)
        }
    },
    async fetchReps ({ commit }) {
        try {
            const response = await usersService.fetchUsersByRole('rep');
            if (!response || !response.data || !response.data.results) {
                throw new Error("API response is missing 'results'");
            }
            commit('LOAD_REP_LIST', { reps: response.data.results });
        } catch (error) {
            console.error("Error fetching reps:", error);
        }
    },
}
